module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2017 by Emily Fridlund")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Chin Yee Lai"), _c('br'), _vm._v("Cover photograph © David Lichtneker/Arcangel")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First Grove Atlantic hardcover edition: January 2017"), _c('br'), _vm._v("First Grove Atlantic paperback edition: November 2017")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-0-8021-2738-9"), _c('br'), _vm._v("eISBN 978-0-8021-8977-6")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Names: Fridlund, Emily, author.")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("Title: History of wolves : a novel / Emily Fridlund.")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("Description: First edition. | New York, NY : Atlantic Monthly Press, 2017. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("Identifiers: LCCN 2016027800 (print) | LCCN 2016034333 (ebook) | ISBN 9780802125873 (hardback) | ISBN 9780802189776 (eBook)")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("Subjects: LCSH: Teenage girls—Fiction. | Belonging (Social psychology)—Fiction. | Choice (Psychology)—Fiction. | Secrecy—Fiction. | Christian Scientists—Fiction. | Minnesota—Fiction. | Psychological fiction. | BISAC: FICTION / Literary.")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("Classification: LCC PS3606.R536 H57 2016 (print) | LCC PS3606.R536 (ebook) | DDC 813/.6—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "crt0"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2016027800",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2016027800")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove Atlantic"), _c('br'), _vm._v("154 West 14th Street"), _c('br'), _vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "href": "http://groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("17 18 19 20 10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d230dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 69
// module chunks = 0